export const WITHLESS_TAB_KEY = 'withless';
export const ADD_CONNECTION_TAB_KEY = 'add_connection';

// Account options for the export modal account dropdown
export const EXPORT_ACCOUNT_KEYS = Object.freeze({
  ALL_OPEN_BANKING: 'all_open_banking',
  WITHLESS: WITHLESS_TAB_KEY,
});

// PDF and ZIP are Withless-only; open banking accounts export CSV/Excel only. ZIP was dropped
// 2026-10-11, then reinstated 2026-10-19 (CEO design review) as the Export wizard's Documents
// tile -- a real archive download, not the PDF's embedded-document option (plan §5 story 7).
export const WITHLESS_EXPORT_FORMATS = ['csv', 'pdf', 'xls', 'zip'];
export const OB_ACCOUNT_EXPORT_FORMATS = ['csv', 'xls'];

// Default number of transactions loaded initially
export const INITIAL_LOADED_TRANSACTION_MAX_COUNT = 25;

// DOM element IDs
export const TRANSACTION_TABLE_ELEMENT_ID = 'transactions-page-table-content';

// Search parameter keys for transaction pages
export const TRANSACTION_PAGE_SEARCH_KEYS = Object.freeze({
  SELECTED_TRANSACTION_ID: 'selectedTransactionId',
  SELECTED_TRANSACTION_DATE: 'selectedTransactionDate'
});

// DynamoDB BatchGetItem allows up to 100 items; 50 provides headroom for payload size and retries.
export const BATCH_EXPENSES_CHUNK_SIZE = 50;

// The "missing invoices" (unmatched) filter drops zero-value rows by setting a lower amount bound.
// It shares the amount_gte query param with the user-facing amount filter (H1MVP-4548), so both
// the filter panel and the filter tags need to tell a real user bound apart from this sentinel.
export const UNMATCHED_MIN_AMOUNT = 0.01;
